/* eslint-disable */
module.exports = function supportsMediaRecorder() {
  return typeof MediaRecorder === 'function' && !!MediaRecorder.prototype && typeof MediaRecorder.prototype.start === 'function';
};


// WEBPACK FOOTER //
// ./src/components/utils/FileUploader/webcam/supportsMediaRecorder.js